<pr-status-label
  class="w-16"
  [dense]="dense"
  [label]="status"
  [color]="statusColourMap[status]"
/>
